import { certificaciones } from '../data/viajes';

/**
 * Marca de un grupo de certificados, en el orden en que se muestran.
 * @typedef {Object} Marca
 * @property {import('../data/viajes').Certificacion['marca']} id
 * @property {string} nombre  texto de su pestaña
 */

/** @type {Marca[]} */
export const MARCAS = [
  { id: 'disney', nombre: 'Disney' },
  { id: 'universal', nombre: 'Universal' },
  { id: 'destinos', nombre: 'Destinos' },
  { id: 'cruceros', nombre: 'Cruceros' }
];

/**
 * Pestaña del carrusel: una marca, cuántos certificados tiene y dónde empieza en la lista.
 * @typedef {Object} GrupoCertificaciones
 * @property {Marca['id']} id
 * @property {string} nombre
 * @property {number} total
 * @property {number} primero  índice de su primer certificado en `lista`
 */

/**
 * Certificados ordenados por marca (Disney, Universal, Destinos, Cruceros; dentro de cada marca, en el orden de los
 * datos) y los grupos para las pestañas del carrusel del celular. Las marcas sin certificados no aparecen.
 * @returns {{ lista: import('../data/viajes').Certificacion[], grupos: GrupoCertificaciones[] }}
 */
export function certificacionesPorMarca() {
  const lista = [];
  const grupos = [];
  MARCAS.forEach((m) => {
    const suyos = certificaciones.filter((c) => c.marca === m.id);
    if (!suyos.length) return;
    grupos.push({ id: m.id, nombre: m.nombre, total: suyos.length, primero: lista.length });
    lista.push(...suyos);
  });
  return { lista, grupos };
}
